import store from '~/store'
import Swal from "sweetalert2";

export default (to, from, next) => {
    const perms = store.getters['auth/user'].permission_names;
    if (perms.indexOf("reports.motivation.show") !== -1 || perms.indexOf("reports.motivation.rop") !== -1) {
        next();
    } else {
        Swal.fire({type: 'warning', title: 'Доступ запрещен!',});
        next({name: 'dashboard'});
    }
}
